import sortingStrategies from "./sortingStrategies.js";

/**
 * `entrySorter` is used to hold the current strategy used to sort the
 * entries when rendered.
 * `entrySorter` also statically exposes the most current sorting strategy.
 */

function entrySorter(my) {
	my ||= {};
	const that = {};

	let currentStrategy = sortingStrategies.sortByNameAZStrategy;

	that.setCurrentStrategy = function (newStrategy) {
		currentStrategy = newStrategy;
	};

	my.getCurrentStrategy = function () {
		return currentStrategy;
	};

	that.sortByNameAZ = function () {
		that.setCurrentStrategy(sortingStrategies.sortByNameAZStrategy);
	};

	that.sortByNameZA = function () {
		that.setCurrentStrategy(sortingStrategies.sortByNameZAStrategy);
	};

	that.sortByCreationTimeAsc = function () {
		that.setCurrentStrategy(
			sortingStrategies.sortByCreationTimeAscStrategy,
		);
	};

	that.sortByCreationTimeDesc = function () {
		that.setCurrentStrategy(
			sortingStrategies.sortByCreationTimeDescStrategy,
		);
	};

	that.sortByModificationTimeAsc = function () {
		that.setCurrentStrategy(
			sortingStrategies.sortByModificationTimeAscStrategy,
		);
	};

	that.sortByModificationTimeDesc = function () {
		that.setCurrentStrategy(
			sortingStrategies.sortByModificationTimeDescStrategy,
		);
	};

	that.currentSortMatch = function (sort) {
		return my.getCurrentStrategy() === sort;
	};

	that.sort = function (collection) {
		collection.sort(my.getCurrentStrategy().sortingFunction());
	};

	return that;
}

export default entrySorter();
